import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {ThemeInstanceContainerModel} from '../../../../../../models/aggregates/cms/theme';

@Injectable({providedIn: 'root'})

export class ThemeInstanceService extends BaseApiTemplateService<ThemeInstanceContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'theme-instances';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'theme-instances';
    this.httpClient = http;
  }
}
